import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import get from 'lodash.get';

// components
import { PdpRespSidebarBlurbLeadTime } from './PdpRespSidebarBlurbLeadTime';
import { PdpRespSidebarBlurbShipping } from './PdpRespSidebarBlurbShipping';
import { deliveryTitle } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpRespSidebarBlurbs.scss';

export function PdpRespSidebarBlurbsComponent(props) {
    const {
        currency,
        relayVariables,
        viewer,
        item,
        user,
        displayInfo,
        shipmentQuote,
        shipment,
        showLeadTimeBlurb,
        sku,
    } = props;
    const pricingDisplayInfo = get(displayInfo, 'pricing') || null;
    const hasValidPricingDisplayInfo = !!pricingDisplayInfo && !pricingDisplayInfo.showUnavailable;
    const renderBlurbs = hasValidPricingDisplayInfo && !pricingDisplayInfo.showSold;

    if (!renderBlurbs) {
        return null;
    }

    return (
        <div className={styles.container}>
            {showLeadTimeBlurb && <PdpRespSidebarBlurbLeadTime item={item} />}
            <PdpRespSidebarBlurbShipping
                currency={currency}
                itemId={relayVariables.itemId}
                item={item}
                userId={relayVariables.userId}
                viewer={viewer}
                user={user}
                shipmentQuote={shipmentQuote}
                shipment={shipment}
                renderTooltip
                sku={sku}
                isClient={relayVariables.isClient}
                title={<span className={styles.title}>{deliveryTitle}</span>}
            />
        </div>
    );
}

PdpRespSidebarBlurbsComponent.defaultProps = {
    showLeadTimeBlurb: true,
};

PdpRespSidebarBlurbsComponent.propTypes = {
    currency: PropTypes.string,
    relayVariables: PropTypes.shape({
        isTrade: PropTypes.bool,
        isVip: PropTypes.bool,
        userId: PropTypes.string,
        itemId: PropTypes.string.isRequired,
        isClient: PropTypes.bool,
    }).isRequired,
    viewer: PropTypes.object,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    displayInfo: PropTypes.object,
    vipUserRelationship: PropTypes.object,
    shipmentQuote: PropTypes.object,
    shipment: PropTypes.object,
    showLeadTimeBlurb: PropTypes.bool,
    sku: PropTypes.object,
};

export const PdpRespSidebarBlurbs = createFragmentContainer(PdpRespSidebarBlurbsComponent, {
    viewer: graphql`
        fragment PdpRespSidebarBlurbs_viewer on Viewer {
            ...PdpRespSidebarBlurbShipping_viewer
        }
    `,
    item: graphql`
        fragment PdpRespSidebarBlurbs_item on Item {
            ...PdpRespSidebarBlurbLeadTime_item
            ...PdpRespSidebarBlurbShipping_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarBlurbs_user on User {
            ...PdpRespSidebarBlurbShipping_user
            ...PdpRespSidebarBlurbShipping_user
        }
    `,
    displayInfo: graphql`
        fragment PdpRespSidebarBlurbs_displayInfo on ItemDisplayInfo {
            pricing {
                showSold
                showUnavailable
            }
        }
    `,
    shipmentQuote: graphql`
        fragment PdpRespSidebarBlurbs_shipmentQuote on ShipmentQuote {
            ...PdpRespSidebarBlurbShipping_shipmentQuote
        }
    `,
    shipment: graphql`
        fragment PdpRespSidebarBlurbs_shipment on Shipment {
            ...PdpRespSidebarBlurbShipping_shipment
        }
    `,
    sku: graphql`
        fragment PdpRespSidebarBlurbs_sku on ItemSkuType {
            ...PdpRespSidebarBlurbShipping_sku
        }
    `,
});
